<app-loading [isLoading]="isLoading()" [isFullSize]="false">
  @if (hasLoadError()) {
    <p class="text-danger mb-0">{{ 'SETTINGS.CONFIGURATION.TEAM_NOTIFICATIONS.LOAD_FAILED' | translate }}</p>
  } @else {
    <div class="table-responsive">
      <table class="table table-hover notification-table notification-matrix">
        <thead>
          <tr>
            <th scope="col" class="notification-table__event">{{ 'SETTINGS.CONFIGURATION.TEAM_NOTIFICATIONS.EVENT' | translate }}</th>
            @for (column of columns; track column) {
              <th scope="col" class="notification-table__column">
                <span>{{ 'SETTINGS.CONFIGURATION.TEAM_NOTIFICATIONS.COLUMNS.' + column + '.LABEL' | translate }}</span>
                <i class="ms-1 lnr lnr-question-circle pointer" tabindex="0" [tooltip]="'SETTINGS.CONFIGURATION.TEAM_NOTIFICATIONS.COLUMNS.' + column + '.TOOLTIP' | translate" container="body" placement="top"></i>
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (item of visibleRows(); track item.def.type) {
            <tr [appSettingAnchor]="item.def.anchorId">
              <th scope="row" class="notification-table__event">
                <div class="notification-table__event-title">{{ 'SETTINGS.CONFIGURATION.TEAM_NOTIFICATIONS.ROWS.' + item.def.key + '.TITLE' | translate }}</div>
                <span class="notification-table__event-description">{{ 'SETTINGS.CONFIGURATION.TEAM_NOTIFICATIONS.ROWS.' + item.def.key + '.DESCRIPTION' | translate }}</span>
              </th>
              @for (column of columns; track column) {
                <td class="notification-table__cell" [attr.aria-busy]="isSaving(item.row, column)">
                  @if (column === 'send_to_custom' && isLegacyLeads(item.row)) {
                    <button class="btn btn-sm v-btn v-btn-light text-nowrap" type="button" (click)="manageLeadList.emit(item.row)">
                      <i class="lnr lnr-pencil me-1"></i>{{ 'SETTINGS.CONFIGURATION.TEAM_NOTIFICATIONS.MANAGE_LIST' | translate }}
                    </button>
                  } @else {
                    <div class="form-check d-inline-block m-0 p-0">
                      <input class="form-check-input" type="checkbox" [id]="cellId(item.row, column)" [checked]="item.row[column]" [disabled]="isSaving(item.row, column)" (change)="toggle(item.row, column)" />
                      <label class="form-check-label visually-hidden" [for]="cellId(item.row, column)">{{ 'SETTINGS.CONFIGURATION.TEAM_NOTIFICATIONS.ROWS.' + item.def.key + '.TITLE' | translate }} – {{ 'SETTINGS.CONFIGURATION.TEAM_NOTIFICATIONS.COLUMNS.' + column + '.LABEL' | translate }}</label>
                    </div>
                  }
                </td>
              }
            </tr>
            @if (item.row.send_to_custom && !isLegacyLeads(item.row)) {
              <tr class="notification-table__emails">
                <td></td>
                <td [attr.colspan]="columns.length">
                  <label class="form-label small text-muted" [for]="cellId(item.row, 'custom_emails')">{{ 'SETTINGS.CONFIGURATION.TEAM_NOTIFICATIONS.ADDITIONAL_EMAILS_LABEL' | translate }}</label>
                  <app-report-recipients-input [id]="cellId(item.row, 'custom_emails')" [maxItems]="20" [ngModel]="item.row.custom_emails" (ngModelChange)="onEmailsChange(item.row, $event)" [placeholder]="'SETTINGS.CONFIGURATION.TEAM_NOTIFICATIONS.ADDITIONAL_EMAILS_PLACEHOLDER' | translate"></app-report-recipients-input>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  }
</app-loading>
